export const lang={
    indexname:'惠威swan',
    index_li1:'品牌故事',
    index_li2:'产品',
    index_li3:'关于我们',
    index_li4:'常见问题',
    index_li5:'联系我们',
    go_home:'返回首页',
    Record_1:'© X-Speaker 2026',
    Record_2:'粤ICP备11013245号',
    detail_title:'X-Speaker品牌介绍',
    list_header:'技术规格',
    RMB:'RMB',
    list_Freight:'运费 : ',
    list_Freight1:'免运费',
    
    Product_Buy_now:'立即购买',
    about_text1:'HiVi-Swans惠威源自中国，名誉业界。经过30年的发展，HiVi-Swans惠威已经成为世界著名高级音响制造公司，并以各类杰出的电声产品享誉业界。',
    about_text2:'HiVi-Swans标志源于HiVi惠威于1997年收购的美国Swans音响公司。',
    about_text3:'HiVi-Swans惠威产品覆盖Hi-Fi高保真、家庭影院、多媒体有源音响、功率放大器、互联网云音响、高保真耳机、汽车音响、专业音响、智能广播、会议系统和扬声器单元制造等多个领域。',
    about_text4:'HiVi-Swans惠威拥有各类尖端的电声研发软硬件设施，包括两座国际电声界超大型截止频率分别低达50Hz和60Hz的专业电声消声室，这是研发电声产品及技术开发重要的专业设施，确保HiVi-Swans惠威在行业内的科技领先地位。',
    about_text5:'HiVi-Swans惠威累计荣获17次CES Innovation Awards创新大奖，包含两次Best of CES冠军大奖，卓显HiVi-Swans惠威不断追求创新电声科技的能力。',
    about_text6:'作为Hi-End高级音响制造商，HiVi-Swans惠威在国际上获得如此评价：HiVi-Swans惠威以先进的电声科技结合中国精密工业制造，产品拥有卓越的声音品质与性价比。',
    about_text7:'HiVi-Swans惠威扬声器单元以超卓的品质及尽善尽美的音质，赢得众多欧美著名音响厂商的青睐与采用，他们认为高品质的惠威扬声器是其品牌引领音响业界潮流的根本保证。',
    about_text8:'HiVi-Swans惠威为中国A股上市公司，股票名称“惠威科技”，代码：sz.002888。',
    about_text9:'HiVi-Swans惠威致力于追求尽善尽美的声音重放，HiVi-Swans惠威的企业理念： HiVi-Swans hear the difference 惠威-专注声音品质',
    about_text10:'©2020 HiVi and the Swans logo are registered trademarks of HiVi-Swans or its subsidiaries in China and other countries. All rights reserved.',
    phone:'电话',
    Callus:`  <p>如有任何问题请与我们联系！</p>
    <p>为您在线解答售前(5×8)、售后咨询(7×24)服务。</p>
    <p>电话：4000909199</p>
    <br>
    <p>地址：深圳市南山区沙河街道高发社区侨香路4068号智慧广场A栋1101</p>
    <p>邮编：518053</p>
    <p>电话总机：0755-82732010</p>
    <p>电邮：hrsz@hivi.com</p>`



































}